module.exports = __webpack_public_path__ + "static/media/art-robot.a9609ee4.png";